import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e3159ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "carousel-container" }
const _hoisted_3 = {
  id: "about",
  class: "company-profile global-container"
}
const _hoisted_4 = { class: "development-title" }
const _hoisted_5 = { class: "brief" }
const _hoisted_6 = { class: "brief-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 启愉智能（INSPIRER）是以研发制造 AI 智能养鱼系统为主的科技创新型企业， 致力为新手零基础养鱼、发烧友轻松托管，提供智慧产品和生态服务， 并实现水族 / 水产养护的科学、轻松、共赢的未来。 ", -1))
const _hoisted_8 = { class: "brief-tags" }
const _hoisted_9 = { class: "stats-showcase" }
const _hoisted_10 = { class: "experience-container" }
const _hoisted_11 = { class: "num" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "physical-container" }
const _hoisted_14 = {
  id: "history",
  class: "development-container"
}
const _hoisted_15 = { class: "development-title" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<svg class=\"tl-svg\" viewBox=\"0 0 1200 420\" preserveAspectRatio=\"none\" data-v-2e3159ae><defs data-v-2e3159ae><linearGradient id=\"tlGrad\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"0.6\" data-v-2e3159ae><stop offset=\"0\" stop-color=\"#0c63b5\" data-v-2e3159ae></stop><stop offset=\"0.55\" stop-color=\"#1f7ac0\" data-v-2e3159ae></stop><stop offset=\"1\" stop-color=\"#ff6900\" data-v-2e3159ae></stop></linearGradient></defs><path class=\"tl-track\" fill=\"none\" stroke=\"#dfe5ec\" stroke-width=\"3\" stroke-linecap=\"round\" d=\"M 150 70 H 1050 A 115 115 0 0 1 1050 300 H 150\" data-v-2e3159ae></path><path id=\"tlPath\" class=\"tl-path\" fill=\"none\" stroke=\"url(#tlGrad)\" stroke-width=\"3\" stroke-linecap=\"round\" pathLength=\"1000\" d=\"M 150 70 H 1050 A 115 115 0 0 1 1050 300 H 150\" data-v-2e3159ae></path><path class=\"tl-flow\" fill=\"none\" stroke=\"#ff8a3c\" stroke-width=\"4\" stroke-linecap=\"round\" pathLength=\"1000\" d=\"M 150 70 H 1050 A 115 115 0 0 1 1050 300 H 150\" data-v-2e3159ae></path></svg>", 1)
const _hoisted_17 = { class: "date" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = {
  id: "products",
  class: "products-container"
}
const _hoisted_20 = {
  class: "development-title",
  style: { marginTop: '100px' }
}
const _hoisted_21 = { class: "introduce-item" }
const _hoisted_22 = { class: "thumb" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = {
  id: "system",
  class: "system-container"
}
const _hoisted_25 = { class: "development-title" }
const _hoisted_26 = { class: "system-layers" }
const _hoisted_27 = { class: "layer-index" }
const _hoisted_28 = { class: "layer-head" }
const _hoisted_29 = { class: "layer-name" }
const _hoisted_30 = { class: "layer-sub" }
const _hoisted_31 = { class: "layer-tags" }
const _hoisted_32 = { class: "banner-container" }
const _hoisted_33 = { class: "footerInfo-contact" }

import { oss } from "@/utils/oss";
import Carousel from "../components/Carousel.vue";
import FooterInfo from "../components/FooterInfo.vue";
import testBnner from "../components/testBnner.vue";
import GenericTitle from "../components/GenericTitle.vue";
import { reactive, ref, onMounted, onBeforeUnmount } from "vue";
const IntroduChinese = "企业简介";
const IntroduEnglish = "About us";
const develuChinese = "发展历程";
const develuEnglish = "History";
const prdChinese = "产品与服务";
const prdEnglish = "Introduction";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const homeCarData = reactive([
  {
    image: oss("home/Maskgroup@1.png"),
    altText: "启愉智能鱼缸",
    describe: {
      title: "启愉智能鱼缸",
      introduction:
          "一次智能选择，十年轻松养鱼。启愉智能以 AI 智能养鱼系统为核心，让新手零基础也能轻松养好鱼。",
    },
  },
  {
    image: oss("home/Maskgroup@2.png"),
    altText: "启愉智慧鱼池",
    describe: {
      title: "启愉智慧鱼池",
      introduction:
          "面向别墅、会所等场景，提供定制化智慧鱼池方案，实时监测、智能换水、自清洁滤棉，尽享轻松养护。",
    },
  },
  {
    image: oss("home/Group632@3x.png"),
    altText: "启愉智慧配件",
    describe: {
      title: "启愉智慧配件",
      introduction:
          "智控照明、无级调控水泵、自适应喂食器、双温控加热棒等高性价比智慧配件，为轻松养鱼全面赋能。",
    },
  },
]);
const introductionData = reactive([
  {
    image: oss("qiyu/cloud.png"),
    describe: {
      title: "物联网科技",
      introduction:
          "共建鱼 / 粮 / 药 / 服务的全生态资源，提供实时精准的养护治疗方案，打造一站式生态。",
    },
  },
  {
    image: oss("qiyu/network.png"),
    describe: {
      title: "AIoT 集成系统",
      introduction:
          "AIoT 集成系统 + 创新维生结构，以轻松养鱼的产品解决客户痛点、推动市场增长。",
    },
  },
  {
    image: oss("qiyu/dashboard.png"),
    describe: {
      title: "数据 AI 赋能",
      introduction:
          "以数据采集、算法模型赋能同行产品开发、生态服务和产品营销，推动行业数智升级。",
    },
  },
]);
const aboutData = ref([
  {
    num: "500ms",
    title: "水质监测频次",
  },
  {
    num: "8s",
    title: "换水 + 清洁",
  },
  {
    num: "<10%",
    title: "新手死亡率",
  },
  {
    num: ">61%",
    title: "客户复购率",
  },
]);
const historyData = ref([
  {
    date: "2016.10",
    title: "生产工厂成立",
  },
  {
    date: "2020.11",
    title: "智能鱼缸项目启动",
  },
  {
    date: "2021.10",
    title: "长城杯国际水族展",
  },
  {
    date: "2023.06",
    title: "集成系统迭代发布",
  },
  {
    date: "2023.08",
    title: "获得天使轮投资",
  },
  {
    date: "2024.05",
    title: "大数据管理平台",
  },
  {
    date: "2025.03",
    title: "首例 AI 图像识别",
  },
  {
    date: "2025.11",
    title: "亚太宠物展 + 国际水族展",
  },
]);
const briefTags = reactive([
  "天使轮投资",
  "广州市专精特新产业园",
  "广东省重点建设项目",
  "广州市科技企业孵化器",
  "番禺百亿工程重点项目",
]);
const systemData = reactive([
  {
    name: "硬件执行",
    sub: "提供轻松养鱼体验",
    items: ["智能换水", "过滤清洁", "自动困水", "双重温控", "灯光模拟", "盐度调节"],
  },
  {
    name: "软件服务",
    sub: "提供一站式生态",
    items: ["远程控制", "生态商城", "销售裂变", "客户服务"],
  },
  {
    name: "数据 AI 赋能",
    sub: "提供智慧养鱼赋能",
    items: ["数据监测", "用户习惯", "水质趋势", "视觉采集", "数据分析", "科学决策", "精准需求"],
  },
]);
// 发展历程 S 形时间轴：节点定位 + 滚动入场
const cols = [150, 450, 750, 1050];
const nodePos = (i: number) => {
  const x = i < 4 ? cols[i] : cols[7 - i];
  const top = i < 4 ? 70 : 300; // 对应 SVG 路径两行的 y
  return { left: `${x}px`, top: `${top}px` };
};
const timelineRef = ref<HTMLElement | null>(null);
const tlVisible = ref(false);
let tlObserver: IntersectionObserver | null = null;
onMounted(() => {
  if (timelineRef.value) {
    tlObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) tlVisible.value = true;
        });
      },
      { threshold: 0.25 }
    );
    tlObserver.observe(timelineRef.value);
  }
});
onBeforeUnmount(() => tlObserver?.disconnect());


return (_ctx: any,_cache: any) => {
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Carousel, { carouselData: homeCarData }, null, 8, ["carouselData"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(GenericTitle, {
          chineseText: IntroduChinese,
          englishText: IntroduEnglish
        })
      ])), [
        [_directive_reveal]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(briefTags, (t, i) => {
              return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: "brief-img",
          style: _normalizeStyle({ backgroundImage: `url(${_unref(oss)('启愉.png')})` })
        }, null, 4)
      ])), [
        [_directive_reveal, 120]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutData.value, (exp, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "experience-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(exp.num), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(exp.title), 1)
          ])), [
            [_directive_reveal, index * 90]
          ])
        }), 128))
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createVNode(testBnner)
      ])), [
        [_directive_reveal]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
        _createVNode(GenericTitle, {
          chineseText: develuChinese,
          englishText: develuEnglish
        })
      ])), [
        [_directive_reveal]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["timeline", { visible: tlVisible.value }]),
        ref_key: "timelineRef",
        ref: timelineRef
      }, [
        _hoisted_16,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyData.value, (dev, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["node", index < 4 ? 'top' : 'bottom']),
            key: index,
            style: _normalizeStyle(nodePos(index))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["dot", { accent: index % 2 === 1 }])
            }, null, 2),
            _createElementVNode("div", _hoisted_17, _toDisplayString(dev.date), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(dev.title), 1)
          ], 6))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
        _createVNode(GenericTitle, {
          chineseText: prdChinese,
          englishText: prdEnglish
        })
      ])), [
        [_directive_reveal]
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introductionData, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "introduce-container",
            key: index
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: "bg",
                style: _normalizeStyle({ backgroundImage: `url(${item.image})` })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h2", null, _toDisplayString(item.describe.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.describe.introduction), 1)
            ])
          ])), [
            [_directive_reveal, index * 120]
          ])
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
        _createVNode(GenericTitle, {
          chineseText: "数智养鱼系统",
          englishText: "Smart Aquaculture System"
        })
      ])), [
        [_directive_reveal]
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemData, (layer, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "layer",
            key: index
          }, [
            _createElementVNode("div", _hoisted_27, "0" + _toDisplayString(index + 1), 1),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(layer.name), 1),
              _createElementVNode("span", _hoisted_30, _toDisplayString(layer.sub), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.items, (t, ti) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "tag",
                  key: ti
                }, _toDisplayString(t), 1))
              }), 128))
            ])
          ])), [
            [_directive_reveal, index * 120]
          ])
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _withDirectives((_openBlock(), _createElementBlock("p", null, [
        _createTextVNode("一次智能选择 · 十年轻松养鱼")
      ])), [
        [_directive_reveal]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("p", null, [
        _createTextVNode("AI 智能养鱼系统 · 开启轻松养鱼新体验")
      ])), [
        [_directive_reveal, 120]
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(FooterInfo)
    ])
  ]))
}
}

})